import {
  ACCOUNT_SERVICE,
  API_VERSION,
  X_API_VERSION,
} from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_BILLING_COMMITMENTS = `${ACCOUNT_SERVICE}/billing-commitments`;

export const billingCommitments = {
  getAll: async ({ filters, sort, params, signal } = {}) => {
    const options = await apiOptions({
      url: API_BILLING_COMMITMENTS,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      signal,
      params,
      filters,
      sort,
    });
    return apiRequest(options);
  },
  getById: async ({ id } = {}) => {
    const options = await apiOptions({
      url: `${API_BILLING_COMMITMENTS}/${id}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options);
  },
  create: async ({ data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: API_BILLING_COMMITMENTS,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  update: async ({ id, data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_BILLING_COMMITMENTS}/${id}`,
      method: "patch",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  getCreateOptions: ({ data } = {}) => {
    return apiOptions({
      url: API_BILLING_COMMITMENTS,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
  },
  getUpdateOptions: ({ id, data } = {}) => {
    return apiOptions({
      url: `${API_BILLING_COMMITMENTS}/${id}`,
      method: "patch",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
  },
  delete: async ({ id, modifiedOn, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_BILLING_COMMITMENTS}/${id}`,
      method: "delete",
      headers: { [X_API_VERSION]: API_VERSION },
      data: { modifiedOn },
    });
    return apiRequest(options, toastMessageConfig);
  },
  voidOptions: async ({ id, modifiedOn }) => {
    return apiOptions({
      url: `${API_BILLING_COMMITMENTS}/${id}/void`,
      method: "put",
      headers: { [X_API_VERSION]: API_VERSION },
      data: { modifiedOn },
    });
  },
};
